export default {
    parseColor(value) {
        if (typeof value !== 'string') return null;

        let r, g, b, a = 1, h, s, l, v;
        let source = 'unknown';

        // RGB格式
        if (value.startsWith('rgb(')) {
            source = 'rgb';
            const match = value.match(/rgb\((\d+),\s*(\d+),\s*(\d+)\)/);
            if (match) {
                r = parseInt(match[1]); g = parseInt(match[2]); b = parseInt(match[3]);
            }
        }
        // RGBA格式
        else if (value.startsWith('rgba(')) {
            source = 'rgba';
            const match = value.match(/rgba\((\d+),\s*(\d+),\s*(\d+),\s*([\d.]+)\)/);
            if (match) {
                r = parseInt(match[1]); g = parseInt(match[2]); b = parseInt(match[3]); a = parseFloat(match[4]);
            }
        }
        // 十六进制3位
        else if (/^#([0-9a-f]{3})$/i.test(value)) {
            source = 'hex';
            const hex = value.substring(1);
            r = parseInt(hex[0] + hex[0], 16);
            g = parseInt(hex[1] + hex[1], 16);
            b = parseInt(hex[2] + hex[2], 16);
        }
        // 十六进制6位
        else if (/^#([0-9a-f]{6})$/i.test(value)) {
            source = 'hex';
            const hex = value.substring(1);
            r = parseInt(hex.substring(0, 2), 16);
            g = parseInt(hex.substring(2, 4), 16);
            b = parseInt(hex.substring(4, 6), 16);
        }
        // 十六进制8位（带透明度）
        else if (/^#([0-9a-f]{8})$/i.test(value)) {
            source = 'hex8';
            const hex = value.substring(1);
            r = parseInt(hex.substring(0, 2), 16);
            g = parseInt(hex.substring(2, 4), 16);
            b = parseInt(hex.substring(4, 6), 16);
            a = parseInt(hex.substring(6, 8), 16) / 255;
        }
        // HSL格式
        else if (value.startsWith('hsl(')) {
            source = 'hsl';
            const match = value.match(/hsl\((\d+),\s*(\d+)%,\s*(\d+)%\)/);
            if (match) {
                h = parseInt(match[1]); s = parseInt(match[2]) / 100; l = parseInt(match[3]) / 100;
                const rgb = this.hslToRgb(h, s, l);
                r = rgb.r; g = rgb.g; b = rgb.b;
            }
        }
        // HSLA格式
        else if (value.startsWith('hsla(')) {
            source = 'hsla';
            const match = value.match(/hsla\((\d+),\s*(\d+)%,\s*(\d+)%,\s*([\d.]+)\)/);
            if (match) {
                h = parseInt(match[1]); s = parseInt(match[2]) / 100; l = parseInt(match[3]) / 100; a = parseFloat(match[4]);
                const rgb = this.hslToRgb(h, s, l);
                r = rgb.r; g = rgb.g; b = rgb.b;
            }
        }
        // HSV格式（非CSS标准，但处理一下）
        else if (value.startsWith('hsv(')) {
            source = 'hsv';
            const match = value.match(/hsv\((\d+),\s*(\d+)%,\s*(\d+)%\)/);
            if (match) {
                h = parseInt(match[1]); s = parseInt(match[2]) / 100; v = parseInt(match[3]) / 100;
                const rgb = this.hsvToRgb(h, s, v);
                r = rgb.r; g = rgb.g; b = rgb.b;
            }
        }
        // HSVA格式
        else if (value.startsWith('hsva(')) {
            source = 'hsva';
            const match = value.match(/hsva\((\d+),\s*(\d+)%,\s*(\d+)%,\s*([\d.]+)\)/);
            if (match) {
                h = parseInt(match[1]); s = parseInt(match[2]) / 100; v = parseInt(match[3]) / 100; a = parseFloat(match[4]);
                const rgb = this.hsvToRgb(h, s, v);
                r = rgb.r; g = rgb.g; b = rgb.b;
            }
        }
        // 透明度单独值
        else if (/^[\d.]+$/.test(value)) {
            source = 'alpha';
            a = parseFloat(value);
            // 默认黑色背景
            r = 0; g = 0; b = 0;
        }
        // 颜色名称（简单处理几个常见颜色）
        else {
            source = 'name';
            const colorMap = {
                'red': [255, 0, 0], 'green': [0, 128, 0], 'blue': [0, 0, 255],
                'black': [0, 0, 0], 'white': [255, 255, 255], 'gray': [128, 128, 128],
                'yellow': [255, 255, 0], 'cyan': [0, 255, 255], 'magenta': [255, 0, 255],
                'orange': [255, 165, 0], 'purple': [128, 0, 128], 'pink': [255, 192, 203]
            };
            if (colorMap[value.toLowerCase()]) {
                [r, g, b] = colorMap[value.toLowerCase()];
            } else {
                // 无法识别的颜色，返回黑色
                r = 0; g = 0; b = 0;
            }
        }

        // 确保所有值都有默认值
        r = r || 0; g = g || 0; b = b || 0; a = a || 1;

        // 转换为各种格式
        const hsl = this.rgbToHsl(r, g, b, a);
        const hsv = this.rgbToHsv(r, g, b, a);
        const hex = this.rgbToHex(r, g, b);
        const hex8 = this.rgbToHex8(r, g, b, a);

        return {
            hsl: { h: hsl.h, s: hsl.s, l: hsl.l, a: hsl.a },
            hex: hex,
            hex8: hex8,
            rgba: { r, g, b, a },
            hsv: { h: hsv.h, s: hsv.s, v: hsv.v, a: hsv.a },
            oldHue: hsl.h,
            source: source,
            a: a
        };
    },

    // 转换函数
    hslToRgb(h, s, l) {
        h /= 360;
        let r, g, b;

        if (s === 0) {
            r = g = b = l;
        } else {
            const hue2rgb = (p, q, t) => {
                if (t < 0) t += 1;
                if (t > 1) t -= 1;
                if (t < 1/6) return p + (q - p) * 6 * t;
                if (t < 1/2) return q;
                if (t < 2/3) return p + (q - p) * (2/3 - t) * 6;
                return p;
            };

            const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
            const p = 2 * l - q;
            r = hue2rgb(p, q, h + 1/3);
            g = hue2rgb(p, q, h);
            b = hue2rgb(p, q, h - 1/3);
        }

        return {
            r: Math.round(r * 255),
            g: Math.round(g * 255),
            b: Math.round(b * 255)
        };
    },

    hsvToRgb(h, s, v) {
        h /= 60;
        const c = v * s;
        const x = c * (1 - Math.abs((h % 2) - 1));
        let r, g, b;

        if (h >= 0 && h < 1) [r, g, b] = [c, x, 0];
        else if (h >= 1 && h < 2) [r, g, b] = [x, c, 0];
        else if (h >= 2 && h < 3) [r, g, b] = [0, c, x];
        else if (h >= 3 && h < 4) [r, g, b] = [0, x, c];
        else if (h >= 4 && h < 5) [r, g, b] = [x, 0, c];
        else [r, g, b] = [c, 0, x];

        const m = v - c;
        return {
            r: Math.round((r + m) * 255),
            g: Math.round((g + m) * 255),
            b: Math.round((b + m) * 255)
        };
    },

    rgbToHsl(r, g, b, a = 1) {
        r /= 255; g /= 255; b /= 255;
        const max = Math.max(r, g, b);
        const min = Math.min(r, g, b);
        let h, s, l = (max + min) / 2;

        if (max === min) {
            h = s = 0;
        } else {
            const d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            switch (max) {
                case r: h = (g - b) / d + (g < b ? 6 : 0); break;
                case g: h = (b - r) / d + 2; break;
                case b: h = (r - g) / d + 4; break;
            }
            h /= 6;
        }

        return { h: h * 360, s, l, a };
    },

    rgbToHsv(r, g, b, a = 1) {
        r /= 255; g /= 255; b /= 255;
        const max = Math.max(r, g, b);
        const min = Math.min(r, g, b);
        let h, s, v = max;
        const d = max - min;

        s = max === 0 ? 0 : d / max;

        if (max === min) {
            h = 0;
        } else {
            switch (max) {
                case r: h = (g - b) / d + (g < b ? 6 : 0); break;
                case g: h = (b - r) / d + 2; break;
                case b: h = (r - g) / d + 4; break;
            }
            h /= 6;
        }

        return { h: h * 360, s, v, a };
    },

    rgbToHex(r, g, b) {
        return '#' + [r, g, b].map(x => {
            // 修正：使用16进制，并且确保是2位数
            const hex = x.toString(16);
            return hex.length === 1 ? '0' + hex : hex;
        }).join('');
    },

    rgbToHex8(r, g, b, a) {
        // 修正：alpha值转换为16进制
        const alpha = Math.round(a * 255);
        const alphaHex = alpha.toString(16).padStart(2, '0');
        return this.rgbToHex(r, g, b) + alphaHex;
    }
}
